"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeEnum = exports.stepsEnum2 = exports.stepsEnum = exports.rechargeTypeEnum = exports.orderByTypeEnum = exports.isShowlEnum = exports.isShowFilterEnum = exports.handleTypeEnum = exports.handleStatusEnum = exports.goodsTypeFilterEnum = exports.goodsTypeEnum2 = exports.goodsTypeEnum = exports.goodsStatusEnum = exports.goodsLabelEnum = exports.goodsAttrsEnum = exports.executeStatusEnum = exports.deliveryTimeEnum2 = exports.deliveryTimeEnum = exports.cpStatusEnum = exports.couponsGoodsAttrsEnum = exports.brandAuthEnum = exports.batchGoodsTypeEnum = exports.auditStatusEnum = exports.accountTypeEnum = void 0;
// 商品类型
var batchGoodsTypeEnum = exports.batchGoodsTypeEnum = [{
  label: '只含实物商品',
  value: 1
}, {
  label: '含卡券商品',
  value: 2
}];
//操作类型
var handleTypeEnum = exports.handleTypeEnum = [{
  label: '商品上下架',
  value: 1
}, {
  label: '商品调价',
  value: 2
}];
//批量操作状态
var handleStatusEnum = exports.handleStatusEnum = [{
  label: '下架',
  value: 0
}, {
  label: '上架',
  value: 1
}

// {
//   label: '资料准备中',
//   value: 3,
// },
// {
//   label: '可采集',
//   value: 4,
// },
// {
//   label: '已入库',
//   value: 5,
// },
// {
//   label: '暂不入库',
//   value: 6,
// },
// {
//   label: '临时下架',
//   value: 7,
// },
];

//执行状态
var executeStatusEnum = exports.executeStatusEnum = [{
  label: '待执行',
  value: 2
}, {
  label: '已执行',
  value: 1
}];
//采销状态
var cpStatusEnum = exports.cpStatusEnum = [{
  label: '资料准备中',
  value: 1
}, {
  label: '仅采集',
  value: 2
}, {
  label: '已入库',
  value: 3
}, {
  label: '暂不入库',
  value: 4
}, {
  label: '临时下架',
  value: 5
}];
//排序方式
var orderByTypeEnum = exports.orderByTypeEnum = [{
  label: '时间升序',
  value: 1
}, {
  label: '时间降序',
  value: 2
}, {
  label: '自定义升序',
  value: 3
}, {
  label: '自定义降序',
  value: 4
}, {
  label: '浏览量升序',
  value: 5
}, {
  label: '浏览量降序',
  value: 6
}, {
  label: '销量升序',
  value: 7
}, {
  label: '销量降序',
  value: 8
}, {
  label: '库存升序',
  value: 9
}, {
  label: '库存降序',
  value: 10
}];
//商品状态
var typeEnum = exports.typeEnum = [{
  label: '出售中（已上架）',
  value: 1
}, {
  label: '仓库中（未上架）',
  value: 2
}, {
  label: '已售罄',
  value: 3
}, {
  label: '警戒库存',
  value: 4
}, {
  label: '回收站',
  value: 5
}];
// 类型（1：出售中（已上架），2：仓库中（未上架），3：已售罄，4：警戒库存，5：回收站）

var stepsEnum = exports.stepsEnum = [{
  label: '商品信息',
  value: 1
}, {
  label: '规格库存',
  value: 2
}, {
  label: '商品详情',
  value: 3
}, {
  label: '其他设置',
  value: 4
}];
var stepsEnum2 = exports.stepsEnum2 = [{
  label: '商品信息',
  value: 1
}, {
  label: '规格库存',
  value: 2
}, {
  label: '商品详情',
  value: 3
}];
//商品类型
var goodsTypeEnum = exports.goodsTypeEnum = [{
  label: '普通商品（物流发货）',
  value: 1
}, {
  label: '卡券商品（自动发货）',
  value: 2
}, {
  label: '自营卡券（自动发货）',
  value: 12
}, {
  label: '优惠券（自动发货）',
  value: 3
}, {
  label: '家政服务（自动发货）',
  value: 4
}, {
  label: '福豆充值（自助发货）',
  value: 110
}, {
  label: '一卡通（自动发货）',
  value: 18
}];

// 商品类型-列表筛选
var goodsTypeFilterEnum = exports.goodsTypeFilterEnum = [{
  label: '普通商品',
  value: 1
}, {
  label: '卡券商品',
  value: 2
}, {
  label: '自营卡券',
  value: 12
}, {
  label: '优惠券',
  value: 3
}, {
  label: '家政服务',
  value: 4
}, {
  label: '福豆充值',
  value: 110
}, {
  label: '一卡通',
  value: 18
}];

//商品类型-供应商
var goodsTypeEnum2 = exports.goodsTypeEnum2 = [{
  label: '普通商品（物流发货）',
  value: 1
}
// {
//     label: '卡券商品（自动发货）',
//     value: 2,
// },
// {
//     label: '自营卡券（自动发货）',
//     value: 12,
// },
// {
//     label: '优惠券（自动发货）',
//     value: 3,
// },
// {
//     label: '家政服务（自动发货）',
//     value: 4,
// },
];
// 商品状态
var goodsStatusEnum = exports.goodsStatusEnum = [{
  label: '上架',
  value: 1
}, {
  label: '下架',
  value: 0
}];
// 品牌是否授权
var brandAuthEnum = exports.brandAuthEnum = [{
  label: '是',
  value: 0
}, {
  label: '否',
  value: 1
}];
// 发货时间
var deliveryTimeEnum = exports.deliveryTimeEnum = [{
  label: '12小时',
  value: 12
}, {
  label: '24小时',
  value: 24
}, {
  label: '48小时',
  value: 48
}, {
  label: '72小时',
  value: 72
}, {
  label: '其他',
  value: 'other'
}];
// 发货时间-供应商
var deliveryTimeEnum2 = exports.deliveryTimeEnum2 = [{
  label: '12小时',
  value: 12
}, {
  label: '24小时',
  value: 24
}, {
  label: '48小时',
  value: 48
}];

//普通商品属性
var goodsAttrsEnum = exports.goodsAttrsEnum = [{
  label: '天府乡村',
  value: '1'
}, {
  label: '天府粮仓',
  value: '2'
}, {
  label: '老字号',
  value: '3'
}];
//卡券商品属性
var couponsGoodsAttrsEnum = exports.couponsGoodsAttrsEnum = [{
  label: '直充',
  value: 2
}, {
  label: '卡密',
  value: 1
}];

//账号类型
var accountTypeEnum = exports.accountTypeEnum = [{
  label: '手机号',
  value: 1
}, {
  label: 'QQ',
  value: 2
}, {
  label: '其他',
  value: 3
}, {
  label: '无需账号',
  value: 4
}];
//充值类型
var rechargeTypeEnum = exports.rechargeTypeEnum = [{
  label: '实际充值',
  value: 0
}, {
  label: '模拟充值成功',
  value: 1
}, {
  label: '模拟充值失败',
  value: 2
}];
//商品标签
var goodsLabelEnum = exports.goodsLabelEnum = [{
  label: '上新',
  value: 0
}, {
  label: '促销',
  value: 1
}, {
  label: '特卖',
  value: 2
}];

//上架状态
var isShowlEnum = exports.isShowlEnum = [{
  label: '不上架',
  value: 0
}, {
  label: '未上架',
  value: 1
}, {
  label: '已上架',
  value: 2
}, {
  label: '已下架',
  value: 3
}];

//上下架状态筛选
var isShowFilterEnum = exports.isShowFilterEnum = [{
  label: '未上架',
  value: 0
}, {
  label: '上架',
  value: 1
}];

//审核状态
var auditStatusEnum = exports.auditStatusEnum = [{
  label: '通过',
  value: 1
}, {
  label: '不通过',
  value: -1
}, {
  label: '待审核',
  value: 0
}];